// Fragment "strays (lot G)" — rempli par son lot de retrofit ; fusionné dans ./index.js.
// Convention : clés plates pointées, valeurs dans les 3 langues, jamais vides.
export default {
  fr: {
    // StripeConnectCard.jsx — reprise d'onboarding + état d'erreur visible
    "sconn.refreshToast": "L'onboarding Stripe a été interrompu — vous pouvez le reprendre à tout moment.",
    "sconn.statusError": "Impossible de charger le statut Stripe Connect.",
    "sconn.retry": "Réessayer",

    // SpecialtiesEditor.jsx — SUGGESTIONS
    "brand.specialty.naturopathy": "naturopathie",
    "brand.specialty.acupuncture": "acupuncture",
    "brand.specialty.osteopathy": "ostéopathie",
    "brand.specialty.coaching": "coaching",
    "brand.specialty.yoga": "yoga",
    "brand.specialty.physiotherapy": "kinésithérapie",
    "brand.specialty.psychology": "psychologie",
    "brand.specialty.nutrition": "nutrition",
    "brand.specialty.homeopathy": "homéopathie",
    "brand.specialty.reflexology": "réflexologie",
    "brand.specialty.massageTherapy": "massothérapie",
    "brand.specialty.meditation": "méditation",
    "brand.specialty.aromatherapy": "aromathérapie",
    "brand.specialty.herbalMedicine": "phytothérapie",
    "brand.specialty.shiatsu": "shiatsu",

    // ProgramsAdmin.jsx
    "programs.badge.active": "Actif",
    "programs.badge.inactive": "Inactif",
    "programs.badge.featured": "Recommandé",
    "programs.confirmDelete": "Supprimer ?",
    "programs.editor.nameFr": "Nom (FR)",
    "programs.editor.nameEn": "Nom (EN)",
    "programs.editor.taglineFr": "Tagline (FR)",
    "programs.editor.taglineEn": "Tagline (EN)",
    "programs.editor.descriptionFr": "Description (FR)",
    "programs.editor.descriptionEn": "Description (EN)",
    "programs.editor.duration": "Durée (ex: 12 semaines)",
    "programs.editor.price": "Prix ($)",
    "programs.editor.image": "Image",
    "programs.editor.order": "Ordre",
    "programs.editor.featuresFr": "Inclus (FR)",
    "programs.editor.featuresEn": "Inclus (EN)",
    "programs.editor.upload": "Téléverser",
    "programs.editor.addItem": "Ajouter un élément",
    "programs.editor.featured": "Mettre en vedette",
  },
  en: {
    // StripeConnectCard.jsx — onboarding resume + visible error state
    "sconn.refreshToast": "Stripe onboarding was interrupted — you can resume it anytime.",
    "sconn.statusError": "Could not load the Stripe Connect status.",
    "sconn.retry": "Retry",

    // SpecialtiesEditor.jsx — SUGGESTIONS
    "brand.specialty.naturopathy": "Naturopathy",
    "brand.specialty.acupuncture": "Acupuncture",
    "brand.specialty.osteopathy": "Osteopathy",
    "brand.specialty.coaching": "Coaching",
    "brand.specialty.yoga": "Yoga",
    "brand.specialty.physiotherapy": "Physiotherapy",
    "brand.specialty.psychology": "Psychology",
    "brand.specialty.nutrition": "Nutrition",
    "brand.specialty.homeopathy": "Homeopathy",
    "brand.specialty.reflexology": "Reflexology",
    "brand.specialty.massageTherapy": "Massage therapy",
    "brand.specialty.meditation": "Meditation",
    "brand.specialty.aromatherapy": "Aromatherapy",
    "brand.specialty.herbalMedicine": "Herbal medicine",
    "brand.specialty.shiatsu": "Shiatsu",

    // ProgramsAdmin.jsx
    "programs.badge.active": "Active",
    "programs.badge.inactive": "Inactive",
    "programs.badge.featured": "Featured",
    "programs.confirmDelete": "Delete?",
    "programs.editor.nameFr": "Name (FR)",
    "programs.editor.nameEn": "Name (EN)",
    "programs.editor.taglineFr": "Tagline (FR)",
    "programs.editor.taglineEn": "Tagline (EN)",
    "programs.editor.descriptionFr": "Description (FR)",
    "programs.editor.descriptionEn": "Description (EN)",
    "programs.editor.duration": "Duration (ex: 12 weeks)",
    "programs.editor.price": "Price ($)",
    "programs.editor.image": "Image",
    "programs.editor.order": "Order",
    "programs.editor.featuresFr": "Includes (FR)",
    "programs.editor.featuresEn": "Includes (EN)",
    "programs.editor.upload": "Upload",
    "programs.editor.addItem": "Add an item",
    "programs.editor.featured": "Feature this program",
  },
  es: {
    // StripeConnectCard.jsx — reanudación del onboarding + estado de error visible
    "sconn.refreshToast": "El onboarding de Stripe se interrumpió — puedes reanudarlo en cualquier momento.",
    "sconn.statusError": "No se pudo cargar el estado de Stripe Connect.",
    "sconn.retry": "Reintentar",

    // SpecialtiesEditor.jsx — SUGGESTIONS
    "brand.specialty.naturopathy": "Naturopatía",
    "brand.specialty.acupuncture": "Acupuntura",
    "brand.specialty.osteopathy": "Osteopatía",
    "brand.specialty.coaching": "Coaching",
    "brand.specialty.yoga": "Yoga",
    "brand.specialty.physiotherapy": "Fisioterapia",
    "brand.specialty.psychology": "Psicología",
    "brand.specialty.nutrition": "Nutrición",
    "brand.specialty.homeopathy": "Homeopatía",
    "brand.specialty.reflexology": "Reflexología",
    "brand.specialty.massageTherapy": "Masoterapia",
    "brand.specialty.meditation": "Meditación",
    "brand.specialty.aromatherapy": "Aromaterapia",
    "brand.specialty.herbalMedicine": "Fitoterapia",
    "brand.specialty.shiatsu": "Shiatsu",

    // ProgramsAdmin.jsx
    "programs.badge.active": "Activo",
    "programs.badge.inactive": "Inactivo",
    "programs.badge.featured": "Recomendado",
    "programs.confirmDelete": "¿Eliminar?",
    "programs.editor.nameFr": "Nombre (FR)",
    "programs.editor.nameEn": "Nombre (EN)",
    "programs.editor.taglineFr": "Tagline (FR)",
    "programs.editor.taglineEn": "Tagline (EN)",
    "programs.editor.descriptionFr": "Descripción (FR)",
    "programs.editor.descriptionEn": "Descripción (EN)",
    "programs.editor.duration": "Duración (ej: 12 semanas)",
    "programs.editor.price": "Precio ($)",
    "programs.editor.image": "Imagen",
    "programs.editor.order": "Orden",
    "programs.editor.featuresFr": "Incluye (FR)",
    "programs.editor.featuresEn": "Incluye (EN)",
    "programs.editor.upload": "Subir",
    "programs.editor.addItem": "Añadir un elemento",
    "programs.editor.featured": "Destacar este programa",
  },
};
